var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5591 22.9557L28.9758 20.2641C28.6591 19.6307 28.3425 18.5224 28.3425 17.8891V13.9307C28.3425 10.2891 26.1258 6.96406 22.9591 5.53906C22.1675 4.11406 20.7425 3.16406 19.0008 3.16406C17.2591 3.16406 15.6758 4.11406 14.8841 5.53906C11.8758 7.1224 9.65913 10.2891 9.65913 13.9307V17.8891C9.65913 18.5224 9.34246 19.6307 9.0258 20.2641L7.44246 22.9557C6.80913 24.0641 6.6508 25.1724 7.1258 26.2807C7.44246 27.3891 8.39246 28.1807 9.5008 28.4974C12.5091 29.6057 15.8341 30.0807 19.0008 30.0807C22.1675 30.0807 25.4925 29.6057 28.5008 28.4974C29.6091 28.1807 30.4008 27.2307 30.8758 26.1224C31.3508 25.1724 31.1925 23.9057 30.5591 22.9557Z",
    fill: "#5F5F8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4331 31.6641C22.7997 33.5641 21.0581 34.8307 18.9997 34.8307C17.7331 34.8307 16.4664 34.3557 15.6747 33.4057C15.1997 32.9307 14.7247 32.2974 14.5664 31.6641H15.1997C15.5164 31.6641 15.9914 31.8224 16.3081 31.8224C17.2581 31.9807 18.2081 31.9807 18.9997 31.9807C19.9497 31.9807 20.7414 31.9807 21.6914 31.8224C22.0081 31.8224 22.3247 31.8224 22.6414 31.6641H23.4331Z",
    fill: "#5F5F8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f42109858ca6e4bc2e829f44eac2f211.svg";
export { ForwardRef as ReactComponent };